angular.module('dnecom')
    .controller('LocalUsersController', ["$scope", "$http", "$timeout", "wizardModal", "notifications", function ($scope, $http, $timeout, wizardModal, notifications) {
        $scope.team = TemplateData.value('team');
        $scope.stores = TemplateData.value('stores');
        $scope.loading = false;
        $scope.tableInstance = {};
        $scope.localUsers = [];
        $scope.hiddenStores = [];
        $scope.hasLicese = TemplateData.value('hasLicense');

        $scope.showTeamModal = function () {
            var teamModal = wizardModal.open({
                'templateUrl': 'teamModal.html',
                'controller': 'LocalUsersTeamController',
                'size': 'md'
            });

            teamModal.result.then(function (team) {
                $scope.team = team;
            });
        };

        $scope.dtInstanceCallback = function(dtInstance) {
            $scope.tableInstance = dtInstance;
        };

        $scope.dtLocalUsersColumnDefs = [{
            targets: [2, 3, 5],
            orderable: false
        }];

        $scope.searchTable = function(search) {
            $scope.tableInstance.DataTable.search(search);
            $scope.tableInstance.DataTable.draw();
        };

        $scope.init = function() {
            if (!$scope.hasLicese) {
                wizardModal.open({
                    templateUrl: 'licenseUpgradeModal.html',
                    controller: 'licenseUpgradeModalController',
                    size: 'md',
                    windowClass: 'modal-jumbotron',
                    'resolve': {
                        'licenseError': function () {
                            return 'no_user_manager_license';
                        },
                        'store': function() {
                            return null
                        }
                    }
                });
                return;
            }

            if ($scope.team == '') {
                $scope.showTeamModal();
            }

            $scope.getLocalUsers();
        };

        $scope.getLocalUsers = function() {
            $scope.loading = true;
            $http.get(Routing.generate('users_get')).success(function(data) {
                if (data.hasOwnProperty('localUsers')) {
                    $scope.localUsers = data.localUsers;
                } else {
                    notifications.danger('Request error.');
                }
            }).finally(function() {
                $timeout(function() {
                    $scope.loading = false;
                });
            });
        };

        $scope.addLocalUser = function () {
            var newLocalUserModal = wizardModal.open({
                'templateUrl': 'editLocalUser.html',
                'controller': 'LocalUsersModalController',
                'size': 'md',
                'resolve': {
                    'localUser': function() {
                        return {};
                    },
                    'stores': function() {
                        return $scope.stores;
                    }
                }
            });

            newLocalUserModal.result.then(function(localUser) {
                $scope.localUsers.push(localUser);
            });
        };

        $scope.editLocalUser = function (localUser, index) {
            var editLocalUserModal = wizardModal.open({
                'templateUrl': 'editLocalUser.html',
                'controller': 'LocalUsersModalController',
                'size': 'md',
                'resolve': {
                    'localUser': function() {
                        return localUser;
                    },
                    'stores': function() {
                        return $scope.stores;
                    }
                }
            });

            editLocalUserModal.result.then(function(localUser) {
                $scope.localUsers[index] = localUser;
            });
        };

        $scope.deleteLocalUser = function(localUser, index) {
            $http.delete(Routing.generate('users_delete', {
                    id: localUser.id
                }))
                .then(function(response) {
                    if (response.data.success) {
                        $scope.localUsers.splice(index, 1);
                        notifications.success('User has been deleted.');
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function() {
                    notifications.danger('Request error.');
                });
        };

        $scope.$watch('localUsers', function(newValue, oldValue) {
            if (_.size(newValue) !== _.size(oldValue)) {
                for (var id in newValue) {
                    if (newValue[id].stores.length > 3) {
                        $scope.hiddenStores[newValue[id].id] = true;
                    } else {
                        $scope.hiddenStores[newValue[id].id] = false;
                    }
                }
            }
        }, true);
    }])
    .controller('LocalUsersTeamController', ["$scope", "$uibModalInstance", "$http", "$timeout", "notifications", function ($scope, $uibModalInstance, $http, $timeout, notifications) {
        $scope.team = { name: ''};
        $scope.loading = false;
        $scope.teamError = null;

        $scope.cancelTeam = function () {
            document.location.href = '/';
        };

        $scope.saveTeam = function () {
            $scope.teamError = null;
            var pattern = new RegExp('^([a-zA-Z0-9_-]+)$');
            if (!pattern.test($scope.team.name)) {
                $scope.inputInvalid = true;
                return;
            }

            $scope.loading = true;

            $http.post(Routing.generate('users_team_create'), $scope.team)
                .then(function(response) {
                    if (!response.data.success) {
                        $scope.teamError = response.data.message;
                        return;
                    }

                    $timeout(function() {
                        $scope.team = response.data.team;
                        notifications.success('Team name was set successfully');
                        $uibModalInstance.close($scope.team);
                    });
                }, function() {
                    $scope.teamError = 'Request error, please try again';
                })
                .finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                });
        };
    }])
    .controller('LocalUsersModalController', ["$scope", "$uibModalInstance", "$http", "$timeout", "notifications", "localUser", "stores", function ($scope, $uibModalInstance, $http, $timeout, notifications, localUser, stores) {
        $scope.localUser = angular.copy(localUser);
        $scope.stores = angular.copy(stores);
        $scope.loading = false;

        $scope.validateForm = function(form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();

                return false;
            }

            return true;
        };

        $scope.save = function(form) {
            if (!$scope.validateForm(form)) {
                return;
            }

            if ($scope.localUser.id) {
                $scope.edit($scope.localUser);
            } else {
                $scope.add($scope.localUser);
            }
        };

        $scope.edit = function (localUser) {
            $scope.loading = true;
            $http.put(Routing.generate('users_edit', {id: localUser.id}), localUser)
                .then(function (response) {
                    if (response.data.success) {
                        notifications.success('User has been successfully edited.');
                        $uibModalInstance.close(response.data.localUser);
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function () {
                    notifications.danger('Request error.');
                }).finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                });
        };

        $scope.add = function (localUser) {
            $scope.loading = true;
            $http.post(Routing.generate('users_add'), localUser)
                .then(function(response) {
                    if (response.data.success) {
                        notifications.success('User has been successfully added.');
                        $uibModalInstance.close(response.data.localUser);
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function() {
                    notifications.danger('Request error.');
                }).finally(function() {
                    $timeout(function() {
                        $scope.loading = false;
                    });
                });
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss();
        };
    }]);